import { MunicipalitiesDocument, MunicipalitiesQuery, MunicipalitiesQueryVariables, MunicipalityFragment } from 'src/api/api.generated'
import QueryLookup from '../query-lookup/query-lookup'
import { useTranslation } from 'react-i18next'

export type MunicipalityInputProps = {
  value: MunicipalityFragment | { id: string } | null
  onChange: (value: MunicipalityFragment | null) => void
  disabled?: boolean
  error?: boolean
  size?: 'small' | 'medium'
}

export default function MunicipalityInput(props: MunicipalityInputProps) {
  const { error, value, onChange, disabled, size } = props
  const {t} = useTranslation()
  return (
    <QueryLookup<MunicipalityFragment, MunicipalitiesQuery, MunicipalitiesQueryVariables> //
      value={value}
      onChange={onChange}
      queryDocument={MunicipalitiesDocument}
      fetchQueryVariables={(id) => ({ filter: { id: { eq: id } }, limit: 1 })}
      getFetchRecord={(data: MunicipalitiesQuery) => data.municipalities?.[0] || null}
      searchQueryVariables={(text) => (text ? { filter: { name: { startsWith: text } } } : {})}
      getSearchRecords={(data: MunicipalitiesQuery) => data.municipalities || []}
      getOptionLabel={(option) => option.name}
      disabled={disabled}
      error={error}
      size={size}
      noOptionsText={<i>{t('commons.municipality_lookup_tip')}</i>}
    />
  )
}
